module.exports = __webpack_public_path__ + "static/media/img404.54964fa6.png";